import { useCallback, useEffect } from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'

import style from '@src/pages/RecoveryPassword/RecoveryPassword.module.scss'
import { Title } from '@src/components/Title/Title'
import { TabList } from '@src/components/Tablist/TabList'
import { AuthFormEnum } from '@src/types/auth'
import { RecoveryForm } from '@src/pages/RecoveryPassword/RecoveryForm'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { AppDispatch } from '@src/store/store'
import {
  resetState,
  setIsSuccessRecallPassword,
  setIsSuccessRecoveryPassword,
  setNewUserData,
} from '@src/store/ducks/auth/reducer'
import { Modal } from '@src/components/common/Modal/Modal'
import {
  selectIsAuth,
  selectIsSuccessRecallPassword,
  selectIsSuccessRecoveryPassword,
  selectUserData,
} from '@src/store/ducks/auth/selectors'
import { setPageTitle } from '@src/store/ducks/app/reducer'
import useQuery from '@src/hooks/useQuery'

const tabListOptions:Array<{ url: string, title: string }> = [
  {
    url: '/recovery-password/contract',
    title: 'Домашний Интернет и ТВ',
  },
  {
    url: '/recovery-password/phone',
    title: 'Приложение COSMOS TV',
  },
]

export const RecoveryPassword = () => {
  const params = useParams<{ type: AuthFormEnum }>()
  const dispatch = useDispatch<AppDispatch>()
  const isSuccessRecallPassword = useSelector(selectIsSuccessRecallPassword)
  const isSuccessRecoveryPassword = useSelector(selectIsSuccessRecoveryPassword)
  const userData = useSelector(selectUserData)
  const isTv = useQuery('tv')
  const isAuth = useSelector(selectIsAuth)

  useEffect(() => { dispatch(setPageTitle('Восстановление пароля')) }, [dispatch])

  useEffect(() => () => {
    dispatch(resetState())
  }, [dispatch])

  useEffect(() => () => {
    dispatch(setIsSuccessRecallPassword(false))
    dispatch(setIsSuccessRecoveryPassword(false))
  }, [dispatch])

  const closeModal = useCallback(() => {
    dispatch(setIsSuccessRecallPassword(false))
    dispatch(setIsSuccessRecoveryPassword(false))
    dispatch(setNewUserData({ login: '', password: '' }))
  }, [dispatch])

  if (isAuth) {
    return <Redirect to="/" />
  }

  return (
    <div id="login" className={cn(style.login, 'container', style.recoveryHeader)}>
      <div className={style.login__body}>
        {!isTv && (
          <div className={` ${style.return}`}>
            <ReturnBtn type="secondary" url="/login">Вернуться</ReturnBtn>
          </div>
        )}

        <Title title="Восстановление пароля" />
        <div className={style.body}>
          <TabList options={tabListOptions} />
          <RecoveryForm type={params.type} />
        </div>
      </div>
      <Modal isOpen={isSuccessRecallPassword} close={closeModal}>
        {isSuccessRecoveryPassword ? (
          <>
            <div className={style.confirmActions}>
              Ваши новые данные для входа
              <div className={style.box}>
                <span>
                  <span className="blue">
                    Login:
                  </span>
                  {' '}
                  {userData.login}
                </span>
                <span>
                  <span className="blue">
                    Password:
                  </span>
                  {' '}
                  {userData.password}
                </span>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={style.confirmActions}>
              Ваши новые данные для входа отправлены на телефон
            </div>
          </>
        )}
      </Modal>
    </div>
  )
}
